module.exports = __webpack_public_path__ + "static/img/a010.fc2d297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a010.jpg
// module id = sWa3
// module chunks = 0